import { RouterItemType } from "@/app/index";
import LayoutPageErrorBoundary from "./layout/index";

export const routesPageErrorBoundary: RouterItemType[] = [
  {
    path: "/error/500",
    authorize: false,
    element: <LayoutPageErrorBoundary />,
  },
];
